import { BottomNavigation, BottomNavigationAction } from "@material-ui/core";
import HomeIcon from "@material-ui/icons/Home";
import SettingsIcon from "@material-ui/icons/Settings";
import StyleIcon from "@material-ui/icons/Style";
import InboxIcon from '@material-ui/icons/Inbox';
import EmojiEventsIcon from '@material-ui/icons/EmojiEvents';
import React from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { Link, withRouter } from "react-router-dom";
import "../styles/navStyles.css";
import "../styles/masterStyles.css";

//TODO style appropriately and see how to simulate tabs
//TODO set display to none when on splash screen.

const Foot = props => {
    const [value, setValue] = React.useState(0);

    const footerIcon = icon => {
        switch (icon) {
            case "rankings":
                return (
                    <BottomNavigationAction
                        id="rankingsFooterIcon"
                        label="Rankings"
                        icon={<EmojiEventsIcon />}
                        to="/leaderboard"
                        component={NavLink}
                    />
                )

            case "inbox": 
                return (
                    <BottomNavigationAction
                        id="inboxFooterIcon"
                        label="Inbox"
                        icon={<InboxIcon />}
                        to="/notifications"
                        component={NavLink}
                    />
                )

            case "myDecks": 
                return (
                    <BottomNavigationAction
                        id="myDecksFooterIcon"
                        label="Decks"
                        icon={<StyleIcon />}
                        to="/myDecks"
                        component={NavLink}
                    />
                )

            case "settings":
                return (
                    <BottomNavigationAction
                        id="settingsFooterIcon"
                        label="Settings"
                        icon={<SettingsIcon />}
                        to="/settings"
                        component={NavLink}
                    />
                );
            default:
                return (
                    <BottomNavigationAction
                        id="homeFooterIcon"
                        label="Home"
                        icon={<HomeIcon />}
                        to="/home"
                        component={NavLink}
                    />
                );
        }
    };
    
    if (props.auth && props.user_details) {
        const { footerOne, footerTwo, footerThree } = props;
        return (
            <BottomNavigation
                className="footer anchor"
                value={value}
                onChange={(event, newValue) => {
                    setValue(newValue);
                }}
                showLabels
                id="MainFooter"
            >
                {footerIcon('home')}
                {/* {footerIcon(footerOne)} */}
                {footerIcon(footerTwo)}
                {footerIcon(footerThree)}

                {
                    Number(props.newMessages)
                    ? (
                        <div className="footerNotifWidget">!</div>
                    )
                    : null
                }
            </BottomNavigation>
        );
    } else {
        return null;
    }
};

const mapStateToProps = state => {
    const { auth, user_details, newMessages } = state.auth;
    const { footerOne, footerTwo, footerThree } = state.style;
    return { auth, user_details, footerOne, footerTwo, footerThree };
};

const Footer = connect(mapStateToProps)(Foot);

export { Footer };
